function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 17,
  y: 0,
  fill: "white",
  id: "rectLetter",
  rx: 20,
  ry: 20,
  width: "85%",
  height: "80%"
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  className: "svg-line",
  x1: 30,
  y1: 20,
  x2: 30,
  y2: 20,
  id: "first-line"
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  className: "svg-line",
  x1: 30,
  y1: 40,
  x2: 30,
  y2: 40,
  id: "second-line"
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  className: "svg-line",
  x1: 30,
  y1: 60,
  x2: 30,
  y2: 60,
  id: "third-line"
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  className: "svg-line",
  x1: 30,
  y1: 80,
  x2: 30,
  y2: 80,
  id: "fourth-line"
});

var _ref7 = /*#__PURE__*/React.createElement("animate", {
  xlinkHref: "#first-line",
  attributeName: "x2",
  from: 30,
  begin: "2s",
  to: "80%",
  dur: "1s",
  fill: "freeze",
  id: "first-anim"
});

var _ref8 = /*#__PURE__*/React.createElement("animate", {
  xlinkHref: "#second-line",
  attributeName: "x2",
  begin: "2s",
  from: 30,
  to: "50%",
  dur: "1s",
  fill: "freeze",
  id: "second-anim"
});

var _ref9 = /*#__PURE__*/React.createElement("animate", {
  xlinkHref: "#third-line",
  attributeName: "x2",
  begin: "2s",
  from: 30,
  to: "80%",
  dur: "1s",
  fill: "freeze",
  id: "third-anim"
});

var _ref10 = /*#__PURE__*/React.createElement("animate", {
  xlinkHref: "#fourth-line",
  attributeName: "x2",
  begin: "2s",
  from: 30,
  to: "60%",
  dur: "1s",
  fill: "freeze",
  id: "fourth-anim"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "letterPathOne",
  fill: "url(#gradient)",
  d: "M114,146.8l94.07-45.6c7.49-3.63,15.93,2.34,15.93,11.27v76.06c.09,6.45-6.44,11.59-13.84,11.59H15.33A11.46,11.46,0,0,1,4,188.54H4V112.47c0-8.93,8.44-14.9,15.93-11.27L114,146.8l97.08,47.08c6.76,3,11.5.35,12.92-5.35-1.44,6.63-6.21,8.6-13.63,5-13.24-6.43-45.66-22.4-51.5-25C153.71,166.28,114,146.8,114,146.8Z",
  transform: "translate(1 -2)"
});

var SvgLetter = function SvgLetter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "letter-svg",
    viewBox: "0 0 231 200",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#11CEBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1238,
    style: {
      stopColor: "#11C3B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3396,
    style: {
      stopColor: "#10A7A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5652,
    style: {
      stopColor: "#0F8288"
    }
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLetter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/letter.4c761ac3.svg";
export { ForwardRef as ReactComponent };